import { exists } from '@/api'

export interface ShelfTypeConversionInfo {
  shelfType: string
}

export function ShelfTypeConversionInfoFromJSON(
  json: any
): ShelfTypeConversionInfo {
  return {
    shelfType: exists(json, 'shelf_type') ? json.shelf_type : ''
  }
}
